// ©2024 Austin App House. All rights reserved.
import React, { useMemo } from 'react';
import { MDBCol, MDBIcon, MDBRow } from 'mdbreact';
import { connect } from 'react-redux';
import { acceptInvite } from '../../../storage/actions/workOrdersActions';
import prepareFilters from '../../../utils/prepareFilters';
import { getStatus } from '../../../utils/api/get/getWorkOrders';
import DashboardIcon from '../../dashboard/icons/DashboardIcon';

const BulkElements = ({
  selectedWorkOrders,
  activeTab,
  acceptInvite,
  search,
  filters,
}) => {
  const mode = selectedWorkOrders?.length ? 'useIds' : 'useFilters';

  const requestData = useMemo(() => {
    const base = mode === 'useFilters'
      ? {
        ...search,
        filters: prepareFilters(filters),
      }
      : { workOrdersId: selectedWorkOrders };
    return { ...base, ...getStatus(activeTab) };
  }, [mode, search, filters, activeTab, selectedWorkOrders]);

  return (
    <>
      {
        activeTab === 'routed'
          ? (
            <button
              aria-label="Accept work orders"
              className="filter-icon-btn"
              type="button"
              onClick={() => acceptInvite(requestData)}
              title="Accept WO's"
            >
              <DashboardIcon name="confirmedCheck" size={18} strokeWidth="2.2" />
            </button>
          )
          : null
      }
    </>
  );
};

const mapDispatchToProps = {
  acceptInvite,
};

const mapStateToProps = state => ({
  filters: state.workOrder?.filters,
  search: state.workOrder?.searchData,
  activeTab: state.applicationState.activeTab,
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkElements);
